//get all receipt maintenance review data
export const RECEIPT_MAINTENANCE_REVIEW_REQUEST = "RECEIPT_MAINTENANCE_REVIEW_REQUEST";
export const RECEIPT_MAINTENANCE_REVIEW_SUCCESS = "RECEIPT_MAINTENANCE_REVIEW_SUCCESS";
export const RECEIPT_MAINTENANCE_REVIEW_FAIL = "RECEIPT_MAINTENANCE_REVIEW_FAIL";

export const RECEIPT_MAINTENANCE_REVIEW_CLEAR_ERROR = "RECEIPT_MAINTENANCE_CLEAR_ERROR";